import { FC } from 'react';
import Button from '../Button';
import { INoticeItem } from '../../models/boardNotice.model';
import { Table, TableColumnsType } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface IProps {
  data: INoticeItem[];
}

const NoticeTable: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const columns: TableColumnsType<INoticeItem> = [
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      align: 'left',
    },
    {
      title: t('common.column.date'),
      dataIndex: 'regDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD HH:mm'),
    },
    {
      title: t('common.column.writer'),
      dataIndex: 'regMemKorName',
      align: 'center',
    },
  ];

  return (
    <>
      <div className="comm-bx__between">
        <div className="comm-sch_result"><b>{t('common.text.announcements')}</b></div>
        <div className="comm-btn__area">
          <Button
            className="btn-basic pink"
            text="More"
            onClick={() => history.push('/board/notice')}
          />
        </div>
      </div>
      <div className='comm-table__area table-wrap'>
        <Table
          columns={columns}
          dataSource={data}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push(`/board/notice/${record.noticeCode}`);
              },
            };
          }}
          rowClassName="pointer"
          rowKey="noticeCode"
        />
      </div>
    </>
  );
};

export default NoticeTable;
